// extracted by mini-css-extract-plugin
export default {"menu":"_235bF"};